<script setup>
import { computed, defineProps} from 'vue';

const props = defineProps({
    title: String,
    subtitle: [String, Number],
    color: String,
});
</script>

<template>
    <div class="flex items-center gap-4 p-4 bg-white rounded-lg shadow-md">
        <div :class="`p-3 ${color} rounded-full`">
            <slot />
        </div>
        <div>
            <p class="mb-2 text-sm font-medium text-gray-600">{{ title }}</p>
            <p class="text-lg font-semibold text-gray-700">{{ subtitle }}</p>
        </div>
    </div>
</template>